import { useMutation } from 'react-query';
import axios from '../utils/axios-util';

const deleteSeverityRule = async (customer, severityId) => {
  return axios({ url: `/rule/${customer}/${severityId}`, method: 'delete' });
};

const useDeleteSeverityRule = (customer) => {
  return useMutation((severityId) => deleteSeverityRule(customer, severityId));
};

export default useDeleteSeverityRule;
